import type { IconProps } from './IconProps';

export const MatchaFlatGreenIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_159_3098)">
      <path
        d="M11.8148 1.85656C11.7845 1.91722 11.7118 1.94313 11.6499 1.91532C10.7292 1.49637 9.61011 1.35482 8.87457 1.35482C6.23002 1.35482 3.58483 2.64455 3.58483 4.76461C3.58483 5.90142 4.43728 6.86319 5.68341 6.86319C7.06035 6.86319 8.08784 5.85782 8.91817 4.93965C9.6613 4.10932 10.5359 3.19115 11.7814 3.19115C13.1368 3.19115 14.1201 4.19652 14.1201 5.55197C14.1201 7.69415 11.5406 10.0986 7.97788 10.0986C4.41517 10.0986 1.83633 8.19652 1.83633 5.55197C1.83633 3.08183 4.76524 0.852449 7.97852 0.852449C9.61833 0.852449 10.8531 1.19621 11.7618 1.6891C11.8218 1.72196 11.8452 1.79589 11.8148 1.85719V1.85656ZM7.97852 0C3.58483 0 0 3.58483 0 7.97852C0 12.3722 3.58483 16.0006 7.97852 16.0006C12.3722 16.0006 16.0006 12.4158 16.0006 7.97852C16.0006 3.54123 12.4152 0 7.97852 0Z"
        fill="#3CBD68"
      />
    </g>
    <defs>
      <clipPath id="clip0_159_3098">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
